import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext, useMemo } from 'react';
import { useGetResultTileData } from './useGetResultTileData';

// TODO refactor this out once we're out of showroom
export default function useMiddleFrameEvents() {
  const vehicleData = useGetResultTileData();
  const { trackEvent } = useContext(AnalyticsContext);

  const trackClickedMonthlyPayment = useCallback(
    () => trackEvent('Clicked tile tooltip - monthly payment', vehicleData),
    [trackEvent, vehicleData]
  );
  const trackClickedMonthlyPaymentCTA = useCallback(
    () =>
      trackEvent(
        'Clicked within tile tooltip for monthly payment - "Get Financing" CTA',
        vehicleData
      ),
    [trackEvent, vehicleData]
  );
  const trackMarketPlaceClicked = useCallback(() => {
    trackEvent('Clicked tile tooltip - marketplace label', vehicleData);
  }, [trackEvent, vehicleData]);

  return useMemo(
    () => ({
      trackClickedMonthlyPayment,
      trackClickedMonthlyPaymentCTA,
      trackMarketPlaceClicked
    }),
    [
      trackClickedMonthlyPayment,
      trackClickedMonthlyPaymentCTA,
      trackMarketPlaceClicked
    ]
  );
}
